module.exports = __webpack_public_path__ + "2ea2832369f82dc5194a7d87387dfa7d.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/Planilha_direcionamento_recinto.xlsx
// module id = ./src/assets/downloads/Planilha_direcionamento_recinto.xlsx
// module chunks = 1